export default __webpack_public_path__ + "static/media/stereo_06.2298f06b.gif";